import { Users, UserCheck, Target, Flame } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import type { DashboardOverview } from '@/types/dashboard';
import { formatPercent } from '@/lib/utils';

interface StatsCardsProps {
  data?: DashboardOverview;
  isLoading: boolean;
}

const cards = [
  {
    title: 'Total Students',
    icon: Users,
    getValue: (d: DashboardOverview) => String(d.total_students),
  },
  {
    title: 'Active Students',
    icon: UserCheck,
    getValue: (d: DashboardOverview) => String(d.active_students),
    subtitle: 'last 7 days',
  },
  {
    title: 'Completion Rate',
    icon: Target,
    getValue: (d: DashboardOverview) => formatPercent(d.completion_rate),
  },
  {
    title: 'Average Streak',
    icon: Flame,
    getValue: (d: DashboardOverview) => `${d.avg_streak.toFixed(1)} days`,
  },
];

export function StatsCards({ data, isLoading }: StatsCardsProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            <card.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <Skeleton className="h-8 w-24" />
            ) : data ? (
              <>
                <div className="text-2xl font-bold">{card.getValue(data)}</div>
                {card.subtitle && (
                  <p className="text-xs text-muted-foreground">{card.subtitle}</p>
                )}
              </>
            ) : null}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
